import { Navigate } from "react-router-dom";
import { getUserRole } from "../api/api";

export default function AdminRoute({ children }) {
  const role = getUserRole();
  if (role !== "admin") return <Navigate to="/" replace />;
  return children;
}